<template>
    <div class="fundoBaseY" :style="CoresLinhaHorizontalY">
        <div class="tracoRetoY"></div>
        <div class="tracoAngularY"></div>
        <div class="circuloTopY"></div>
        <div class="circulo1Y"></div>
        <div class="circulo2Y"></div>
        <div class="circulo3Y"></div>
        <div class="circulo4Y"></div>
        <div class="quadradoY"></div>
    </div>
</template>

<script>
export default {
    name: "LinhaHorizontalY",
		data() {
			return {
                backgroundLinhasY: "#000",
                CorLinhasY: "#008fac"
            };
		},
	components: {},
    props: ["configLinhasY"],
	computed: {
		CoresLinhaHorizontalY: function () {
			return [
                {"--linhas-background-colorY": this.backgroundLinhasY},
                {"--linhas-colorY": this.CorLinhasY}
            ];
		}
    },
    methods: {
        setConfiguracaoInicialY() {
            if(this.configLinhasY) {
                if (this.configLinhasY.backgroundLinhasY) {
					this.backgroundLinhasY = this.configLinhasY.backgroundLinhasY;
				}
				if (this.configLinhasY.CorLinhasY) {
					this.CorLinhasY = this.configLinhasY.CorLinhasY
				}
            }
        }
    },
    created() {
            this.setConfiguracaoInicialY();
    }
};
</script>

<style>

.fundoBaseY {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: var(--linhas-background-colorY);
}

.tracoRetoY {
    position: absolute;
    top: 15%;
    left:18.5%;
    width: 80%;
    height: 4%;
    background-color: var(--linhas-colorY);
}

.tracoAngularY {
    position: absolute;
    top: 48%;
    left: 0%;
    width: 22%;
    height: 4%;
    background-color: var(--linhas-colorY);
    transform: rotate(-45deg);
}

.quadradoY {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 8%;
    left: 95%;
    background-color: var(--linhas-colorY);
}

.circuloTopY {
    position: absolute;
    width: 4%;
    height: 18%;
    top:79%;
    left: 0.5%;
    border-radius: 50%;
    background-color: var(--linhas-colorY);
}

.circulo1Y {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 8%;
    left: 40%;
    border-radius: 50%;
    background-color: var(--linhas-colorY);
}

.circulo2Y {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 8%;
    left: 50%;
    border-radius: 50%;
    background-color: var(--linhas-colorY);
}

.circulo3Y {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 8%;
    left: 60%;
    border-radius: 50%;
    background-color: var(--linhas-colorY);
}

.circulo4Y {
    position: absolute;
    width: 4%;
    height: 18%;
    top: 8%;
    left: 70%;
    border-radius: 50%;
    background-color: var(--linhas-colorY);
}

</style>